import request from '@/utils/request'
const clientId = process.env.REACT_APP_CLIENT_ID
const clientSecret = process.env.REACT_APP_CLIENT_SECRET

const encodedAuth = window.btoa(`${clientId}:${clientSecret}`)

const authApiRequest = {
  me: (access_token?: string) =>
    request.get('/system/users/me', {
      headers: { Authorization: `Bearer ${access_token}`, fromCore: true }
    }),
  getPermissionFollowUser: (application_id: number, user_id: number) =>
    request.get(`/system/role-permissions/application/${application_id}/user/${user_id}`, {
      headers: { fromCore: true }
    }),
  logout: (token?: String) =>
    request.post(
      '/connect/revocation',
      {
        token: token,
        token_type_hint: 'access_token'
      },
      {
        headers: {
          isLogout: true,
          Authorization: `Basic ${encodedAuth}`
        }
      }
    )
}

export default authApiRequest
